import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function UpgradeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"upgrade"}/>
}
